import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { ref } from 'lit/directives/ref.js';
import { UIModalServiceModal } from '../../../../app/package/base/service/modals/modal-service';
import { I18n } from '../../../base/package/services/package/i18n/i18n.de';

const CName = 'ui-panic-info-modal';

@customElement(CName)
export class UIPanicInfoModal extends UIModalServiceModal {
  public close() {
    this._modalRef.value?.close();
  }

  render() {
    return html`
      <ui-modal
        ${ref(this._modalRef)}
      >
        <div slot="title">${window.$app.$t.get(I18n.panic.infoTitle)}</div>
        <div slot="main">
          ${window.$app.$t.get(I18n.panic.infoText)}
        </div>
      </ui-modal>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: UIPanicInfoModal;
  }
}
